import { fromISTInput, toISTInput } from "@/lib/format";

export const TEXT = ["name", "company", "email", "phone", "source", "status", "setter_id", "closer_id", "loss_reason",
  "meeting_status", "sale_type", "date_booked", "meeting_date", "deposit_date", "date_paid_in_full", "last_touch_date"];
export const MONEY = ["deposit_amount", "total_deal_value", "cash_collected", "refund_amount"];
export const PCT = ["setter_pct", "closer_pct"];
const DATETIME = ["date_created", "first_contact_at"];
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const str = (v) => (v === null || v === undefined ? "" : String(v));
const OFFER_TO_FORM = new Map([[true, "yes"], [false, "no"]]);
const OFFER_FROM_FORM = { yes: true, no: false };

export const toForm = (lead) => {
  const f = {};
  [...TEXT, ...MONEY, ...PCT].forEach((k) => { f[k] = str(lead[k]); });
  DATETIME.forEach((k) => { f[k] = toISTInput(lead[k]); });
  f.offer_made = OFFER_TO_FORM.get(lead.offer_made) ?? "";
  return f;
};

export const toPayload = (f) => {
  const p = {};
  TEXT.forEach((k) => { p[k] = f[k].trim() === "" ? null : f[k].trim(); });
  [...MONEY, ...PCT].forEach((k) => { p[k] = f[k] === "" ? null : Number(f[k]); });
  DATETIME.forEach((k) => { p[k] = fromISTInput(f[k]); });
  p.offer_made = OFFER_FROM_FORM[f.offer_made] ?? null;
  p.name = f.name.trim();
  return p;
};

export const validate = (f) => {
  const e = {};
  if (!f.name.trim()) e.name = "Lead name is required";
  if (f.email.trim() && !EMAIL_RE.test(f.email.trim())) e.email = "Enter a valid email";
  [...MONEY, ...PCT].forEach((k) => {
    if (f[k] === "") return;
    const n = Number(f[k]);
    if (Number.isNaN(n)) e[k] = "Enter a number";
    else if (n < 0) e[k] = "Must be 0 or more";
    else if (PCT.includes(k) && n > 100) e[k] = "Must be 100 or less";
  });
  if (f.status === "Lost" && !f.loss_reason) e.loss_reason = "Loss Reason is required";
  return e;
};
